import React, { useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqItems } from '../../data/artTherapy';
export function FaqList() {
  const [open, setOpen] = useState<number | null>(null);
  const reduce = useReducedMotion();
  return <section aria-labelledby="faq-title" className="bg-peach py-14 md:py-20" data-id="element-62" data-mp="11zfmpnwj4r6l">
      <div className="mx-auto max-w-2xl px-5" data-id="element-63" data-mp="16y0bmr6bzofq">
        <h2 id="faq-title" className="text-center font-display text-[1.75rem] font-extrabold tracking-[-0.03em] text-ink md:text-4xl" data-id="element-64" data-mp="16wxpewjyea65">
          Gyakori <em className="font-serif font-medium tracking-normal text-coral" data-id="element-65" data-mp="1fyf0g0ii7lnz">kérdések</em>
        </h2>

        <ul className="mt-8 space-y-4" data-id="element-66" data-mp="1kwzzvxpxm1bd">
          {faqItems.map((item, i) => {
          const isOpen = open === i;
          return <li key={item.question} className="rounded-3xl border border-[#F1E6E0] bg-white" data-id="element-67" data-mp="3hr360gimel6x" data-mpi={i}>
                <h3 data-id="element-68" data-mp="3mpeiz047pbtd">
                  <button type="button" id={`faq-q-${i}`} aria-expanded={isOpen} aria-controls={`faq-a-${i}`} onClick={() => setOpen(isOpen ? null : i)} className="flex w-full items-center justify-between gap-4 rounded-3xl px-5 py-5 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-lavender-deep" data-id="element-69" data-mp="3mqpjmr2d23g9">
                    <span className="text-[17px] font-bold text-ink" data-id="element-70" data-mp="35jpv2r35v70e">
                      {i + 1}. {item.question}
                    </span>
                    <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-lavender-line bg-lavender-soft text-lavender" data-id="element-71" data-mp="30jlaopz4ts4w">
                      <PlusIcon className={`h-5 w-5 transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-72" data-mp="2rk817xb0d3k6" />
                    </span>
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-73" data-mp="1ho1jtmhc1jqp">
                  {isOpen && <motion.div id={`faq-a-${i}`} role="region" aria-labelledby={`faq-q-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: reduce ? 0 : 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-74" data-mp="1mmmk1lwl43f5">
                      <p className="px-5 pb-5 text-[16px] leading-relaxed text-body" data-id="element-75" data-mp="oz415i97lkxf">{item.answer}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}